import React, { Component } from 'react';
import { Table, Tooltip, Popover, Tag, Modal, Input, Button, message, Spin, Pagination, Image, Select, Upload } from 'antd';
import { SearchOutlined, SendOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Cookies } from 'react-cookie';
import { buildShortProductImageUrl, parseShortProductImages } from '../../utils/shortProductImages';

const cookies = new Cookies();

class ShortProductTable extends Component {

    state = {
        loading: false,
        data: [],
        currentPage: 1,
        lastPage: 1,
        total: 0,

        // 转发邮件弹窗
        forwardModalVisible: false,
        forwardLoading: false,
        forwardSending: false,
        forwardProductId: null,
        forwardMessageId: '',
        forwardSubject: '',
        forwardTo: [],
        forwardCc: [],
        forwardBody: '',
        forwardImagePaths: [],

        // 邮件预览弹窗
        previewModalVisible: false,
        previewMail: null,
        previewLoading: false,

        // 匹配中的产品ID
        matchingId: null,

        // 行级别图片上传中的产品ID
        uploadingId: null,
    }

    componentDidMount() {
        this.fetchList(1);
    }

    getToken = () => cookies.get('token')

    fetchList = (page) => {
        this.setState({ loading: true });
        axios.get(window.api + 'short-product/list?page=' + page + '&token=' + this.getToken())
            .then((response) => {
                this.setState({
                    data: response.data.data,
                    currentPage: response.data.current_page,
                    lastPage: response.data.last_page,
                    total: response.data.total,
                    loading: false,
                });
            })
            .catch((error) => {
                message.error('加载失败');
                this.setState({ loading: false });
            });
    }

    // 匹配邮件
    handleMatchMail = (record) => {
        this.setState({ matchingId: record.id });
        axios.post(window.api + 'short-product/' + record.id + '/match-mail?token=' + this.getToken())
            .then((response) => {
                if (response.data.mail) {
                    message.success('已匹配到邮件');
                } else {
                    message.warning(response.data.messages || '未找到匹配邮件');
                }
                this.setState({ matchingId: null });
                this.fetchList(this.state.currentPage);
            })
            .catch((error) => {
                message.error(error.response?.data?.errors || '匹配失败');
                this.setState({ matchingId: null });
            });
    }

    // 邮件预览
    handlePreviewMail = (record) => {
        if (!record.ab) {
            message.warning('该订单没有AB号');
            return;
        }
        this.setState({ previewModalVisible: true, previewLoading: true, previewMail: null });
        axios.post(window.api + 'short-product/mail/search?token=' + this.getToken(), {
            keyword: record.ab,
        })
            .then((response) => {
                this.setState({
                    previewMail: response.data.mail,
                    previewLoading: false,
                });
            })
            .catch((error) => {
                message.error('加载邮件失败');
                this.setState({ previewLoading: false });
            });
    }

    // 打开转发弹窗
    showForwardModal = (record) => {
        if (!record.short_mail_id) {
            message.warning('请先匹配邮件');
            return;
        }
        this.setState({
            forwardModalVisible: true,
            forwardLoading: true,
            forwardProductId: record.id,
            forwardMessageId: record.short_mail_id,
            forwardSubject: '',
            forwardTo: [],
            forwardCc: [],
            forwardBody: '',
            forwardImagePaths: parseShortProductImages(record.short_images),
        });

        axios.get(window.api + 'short-product/' + record.id + '/forward-prepare?token=' + this.getToken())
            .then((response) => {
                const d = response.data || {};
                this.setState({
                    forwardLoading: false,
                    forwardSubject: d.subject || '',
                    forwardTo: d.to ? [d.to] : [],
                    forwardCc: Array.isArray(d.cc) ? d.cc : [],
                    forwardBody: d.body || '',
                    forwardImagePaths: parseShortProductImages(d.images) || parseShortProductImages(record.short_images),
                });
            })
            .catch((error) => {
                this.setState({ forwardLoading: false });
                message.error(error.response?.data?.errors || '加载转发数据失败');
            });
    }

    // 发送转发
    handleForward = () => {
        const { forwardProductId, forwardMessageId, forwardSubject, forwardTo, forwardCc, forwardBody, forwardImagePaths } = this.state;
        if (!forwardSubject.trim()) {
            message.warning('请输入主题');
            return;
        }
        if (!forwardTo || forwardTo.length === 0) {
            message.warning('请输入收件人');
            return;
        }
        if (!forwardBody.trim()) {
            message.warning('请输入正文');
            return;
        }

        this.setState({ forwardSending: true });
        axios.post(window.api + 'short-product/mail/forward?token=' + this.getToken(), {
            product_id: forwardProductId,
            message_id: forwardMessageId,
            subject: forwardSubject,
            to: forwardTo,
            cc: forwardCc,
            body: forwardBody,
            images: forwardImagePaths,
        })
            .then(() => {
                message.success('转发成功');
                this.setState({ forwardModalVisible: false, forwardSending: false });
                this.fetchList(this.state.currentPage);
            })
            .catch((error) => {
                message.error(error.response?.data?.errors || '转发失败');
                this.setState({ forwardSending: false });
                this.fetchList(this.state.currentPage);
            });
    }

    // 行级图片上传：上传 OSS → 追加到 short_images → 重新标记
    handleUploadImage = (record, file) => {
        const existing = parseShortProductImages(record.short_images);
        if (existing.length >= 10) {
            message.warning('最多 10 张图片');
            return false;
        }
        if (file.size > 4 * 1024 * 1024) {
            message.error('图片不能超过 4MB');
            return false;
        }

        this.setState({ uploadingId: record.id });

        const formData = new FormData();
        formData.append('file', file);
        axios.post(window.api + 'short-product/upload?token=' + this.getToken(), formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((response) => {
                const path = response.data?.path || response.data?.url;
                if (!path) throw new Error('上传未返回路径');
                const next = [...existing, path];
                return axios.post(window.api + 'short-product/' + record.id + '/mark?token=' + this.getToken(), {
                    is_short: 1,
                    short_images: next,
                });
            })
            .then(() => {
                message.success('已添加图片');
                this.setState({ uploadingId: null });
                this.fetchList(this.state.currentPage);
            })
            .catch((error) => {
                message.error(error.response?.data?.errors || error.message || '上传失败');
                this.setState({ uploadingId: null });
            });

        return false; // 阻止 antd 默认上传
    }

    renderMailStatus = (status) => {
        switch (status) {
            case 0: return <Tag>未发送</Tag>;
            case 1: return <Tag color="success">已发送</Tag>;
            case 2: return <Tag color="error">发送失败</Tag>;
            default: return <Tag>未发送</Tag>;
        }
    }

    render() {
        const { loading, data, total, currentPage } = this.state;

        const columns = [
            {
                title: '#',
                key: 'index',
                width: 40,
                render: (_, __, idx) => (currentPage - 1) * 50 + idx + 1,
            },
            {
                title: '产品',
                key: 'product',
                width: 160,
                render: (_, record) => (
                    <>
                        <span>{record.brand_name}</span><br />
                        <span>{record.product_name}</span>
                    </>
                ),
            },
            {
                title: '数量',
                key: 'quantity',
                width: 90,
                render: (_, record) => {
                    const amount = record.amount || 0;
                    const delivered = record.delivered_quantity || 0;
                    const shortage = amount - delivered;
                    return (
                        <>
                            <span>{amount} - {delivered}</span>
                            <span style={{ color: '#f5222d' }}> = {shortage}</span>
                        </>
                    );
                },
            },
            {
                title: '图片',
                key: 'short_images',
                width: 150,
                render: (_, record) => {
                    const images = parseShortProductImages(record.short_images);
                    return (
                        <div>
                            {images.length > 0 && (
                                <Image.PreviewGroup>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: 4 }}>
                                        {images.map((url, i) => (
                                            <Image
                                                key={i}
                                                src={buildShortProductImageUrl(url)}
                                                width={36}
                                                height={36}
                                                style={{ objectFit: 'cover', borderRadius: '3px', border: '1px solid #d9d9d9' }}
                                                preview={{ src: buildShortProductImageUrl(url) }}
                                            />
                                        ))}
                                    </div>
                                </Image.PreviewGroup>
                            )}
                            <Upload
                                accept="image/*"
                                showUploadList={false}
                                beforeUpload={(file) => this.handleUploadImage(record, file)}
                            >
                                <Button
                                    size="small"
                                    icon={<UploadOutlined />}
                                    loading={this.state.uploadingId === record.id}
                                    disabled={images.length >= 10}
                                >
                                    上传
                                </Button>
                            </Upload>
                        </div>
                    );
                },
            },
            {
                title: '标记时间',
                dataIndex: 'short_at',
                key: 'short_at',
                width: 120,
                render: (val) => val ? val.substring(0, 16) : '',
            },
            {
                title: '订单号',
                key: 'order_name',
                width: 100,
                render: (_, record) => (
                    <Link to={'/order/' + record.order_id} target="_blank">
                        {record.order_name}
                    </Link>
                ),
            },
            {
                title: 'AB号',
                dataIndex: 'ab',
                key: 'ab',
                width: 100,
            },
            {
                title: '标记人',
                dataIndex: 'short_by_name',
                key: 'short_by_name',
                width: 70,
            },
            {
                title: '匹配到的邮件',
                key: 'mail',
                width: 180,
                render: (_, record) => {
                    if (record.short_mail_subject) {
                        return (
                            <Popover
                                title={record.short_mail_subject}
                                content={
                                    <div style={{ maxWidth: 400, maxHeight: 300, overflow: 'auto', whiteSpace: 'pre-wrap', fontSize: 12 }}>
                                        {record.short_mail_body_preview}
                                    </div>
                                }
                                trigger="hover"
                            >
                                <span style={{ cursor: 'pointer', color: '#1890ff', textDecoration: 'underline' }}>
                                    {record.short_mail_subject.length > 30
                                        ? record.short_mail_subject.substring(0, 30) + '...'
                                        : record.short_mail_subject}
                                </span>
                            </Popover>
                        );
                    }
                    return (
                        <Button
                            size="small"
                            icon={<SearchOutlined />}
                            loading={this.state.matchingId === record.id}
                            onClick={() => this.handleMatchMail(record)}
                            disabled={!record.ab}
                        >
                            匹配邮件
                        </Button>
                    );
                },
            },
            {
                title: '发送预览',
                key: 'reply_preview',
                width: 80,
                render: (_, record) => {
                    if (record.short_reply_body) {
                        return (
                            <Popover
                                title="发送内容"
                                content={
                                    <div style={{ maxWidth: 400, maxHeight: 200, overflow: 'auto', whiteSpace: 'pre-wrap', fontSize: 12 }}>
                                        {record.short_reply_body}
                                        {record.short_reply_at && <div style={{ marginTop: 8, color: '#999' }}>发送于: {record.short_reply_at}</div>}
                                    </div>
                                }
                                trigger="hover"
                            >
                                <Button size="small" icon={<EyeOutlined />}>查看</Button>
                            </Popover>
                        );
                    }
                    return <span style={{ color: '#999' }}>-</span>;
                },
            },
            {
                title: '转发',
                key: 'forward',
                width: 70,
                render: (_, record) => {
                    const sent = record.short_mail_status === 1;
                    const disabled = !record.short_mail_id || sent;
                    return (
                        <Button
                            size="small"
                            icon={<SendOutlined />}
                            type={!disabled ? 'primary' : 'default'}
                            disabled={disabled}
                            onClick={() => this.showForwardModal(record)}
                        >
                            转发
                        </Button>
                    );
                },
            },
            {
                title: '状态',
                key: 'status',
                width: 70,
                render: (_, record) => this.renderMailStatus(record.short_mail_status),
            },
        ];

        return (
            <>
                <Spin spinning={loading}>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="id"
                        pagination={false}
                        size="small"
                        bordered
                        scroll={{ x: 1250 }}
                    />
                </Spin>

                {total > 50 && (
                    <div style={{ textAlign: 'center', marginTop: 16 }}>
                        <Pagination
                            current={currentPage}
                            total={total}
                            pageSize={50}
                            onChange={(page) => this.fetchList(page)}
                            showTotal={(total) => `共 ${total} 条`}
                        />
                    </div>
                )}

                {/* 转发邮件弹窗 */}
                <Modal
                    title="转发邮件"
                    open={this.state.forwardModalVisible}
                    onOk={this.handleForward}
                    onCancel={() => this.setState({ forwardModalVisible: false })}
                    okText="发送"
                    cancelText="取消"
                    confirmLoading={this.state.forwardSending}
                    width={680}
                    okButtonProps={{ disabled: this.state.forwardLoading }}
                >
                    <Spin spinning={this.state.forwardLoading}>
                        <div style={{ marginBottom: 8 }}>主题：</div>
                        <Input
                            value={this.state.forwardSubject}
                            onChange={e => this.setState({ forwardSubject: e.target.value })}
                            placeholder="邮件主题"
                            style={{ marginBottom: 12 }}
                        />

                        <div style={{ marginBottom: 8 }}>收件人 (To)：</div>
                        <Select
                            mode="tags"
                            value={this.state.forwardTo}
                            onChange={(v) => this.setState({ forwardTo: v })}
                            placeholder="输入邮箱后回车，可多个"
                            tokenSeparators={[',', ';', ' ']}
                            style={{ width: '100%', marginBottom: 12 }}
                        />

                        <div style={{ marginBottom: 8 }}>抄送 (Cc)：</div>
                        <Select
                            mode="tags"
                            value={this.state.forwardCc}
                            onChange={(v) => this.setState({ forwardCc: v })}
                            placeholder="自动根据品牌渠道带出，可编辑"
                            tokenSeparators={[',', ';', ' ']}
                            style={{ width: '100%', marginBottom: 12 }}
                        />

                        <div style={{ marginBottom: 8 }}>正文（纯文本）：</div>
                        <Input.TextArea
                            rows={14}
                            value={this.state.forwardBody}
                            onChange={e => this.setState({ forwardBody: e.target.value })}
                            placeholder="请输入正文..."
                            maxLength={10000}
                        />

                        {this.state.forwardImagePaths && this.state.forwardImagePaths.length > 0 && (
                            <>
                                <div style={{ marginTop: 12, marginBottom: 8 }}>附件图片：</div>
                                <Image.PreviewGroup>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                        {this.state.forwardImagePaths.map((url, i) => (
                                            <Image
                                                key={i}
                                                src={buildShortProductImageUrl(url)}
                                                width={60}
                                                height={60}
                                                style={{ objectFit: 'cover', borderRadius: '4px', border: '1px solid #d9d9d9' }}
                                                preview={{ src: buildShortProductImageUrl(url) }}
                                            />
                                        ))}
                                    </div>
                                </Image.PreviewGroup>
                            </>
                        )}
                    </Spin>
                </Modal>

                {/* 邮件预览弹窗 */}
                <Modal
                    title="邮件预览"
                    open={this.state.previewModalVisible}
                    onCancel={() => this.setState({ previewModalVisible: false })}
                    footer={null}
                    width={700}
                >
                    <Spin spinning={this.state.previewLoading}>
                        {this.state.previewMail ? (
                            <div>
                                <p><strong>标题:</strong> {this.state.previewMail.subject}</p>
                                <p><strong>发件人:</strong> {this.state.previewMail.from?.name} &lt;{this.state.previewMail.from?.address}&gt;</p>
                                <p><strong>时间:</strong> {this.state.previewMail.received_at}</p>
                                <hr />
                                <div
                                    style={{ maxHeight: 400, overflow: 'auto' }}
                                    dangerouslySetInnerHTML={{
                                        __html: this.state.previewMail.body?.content_type === 'html'
                                            ? this.state.previewMail.body?.content
                                            : '<pre>' + (this.state.previewMail.body?.content || '') + '</pre>'
                                    }}
                                />
                            </div>
                        ) : (
                            !this.state.previewLoading && <p>未找到匹配邮件</p>
                        )}
                    </Spin>
                </Modal>
            </>
        );
    }
}

export default ShortProductTable;
